export * from "./registereduser.component";
export * from "./viewparent.component";
export * from "./editparent.component";
export * from "./searchparent.component";



// WEBPACK FOOTER //
// ./src/app/registereduser/index.ts